import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { DialogFooterModule } from '@ruby/shared/dialogs/dialog-footer/dialog-footer.module';
import { DialogHeaderModule } from '@ruby/shared/dialogs/dialog-header/dialog-header.module';
import { DiversionsWaybilllPreviewDialog } from '@ruby/shared/dialogs/diversions/waybill-preview/component/waybill-preview.dialog';
import { DiversionsWaybilllPreviewContainer } from '@ruby/shared/dialogs/diversions/waybill-preview/container/waybill-preview.container';

@NgModule({
  declarations: [
    DiversionsWaybilllPreviewDialog,
    DiversionsWaybilllPreviewContainer
  ],
  imports: [
    CommonModule,
    DialogHeaderModule,
    DialogFooterModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule
  ],
  exports: [DiversionsWaybilllPreviewContainer]
})
export class DiversionsWaybilllPreviewModule {}
